export enum DeviceType {
	APNS = 'apns',
	FCM = 'fcm',
}

export enum PlatformName {
	Android = 'android',
	iOS = 'ios',
}
